
import {defineComponent} from 'vue'
import axios from "axios";
import {User} from '@/store';
import {lookupURL} from "@/config/app-settings";
import InputText from "primevue/inputtext";
import MultiSelect from "primevue/multiselect";
import Dropdown from "primevue/dropdown";

export default defineComponent({
  name: "ProfileForm",
  components: {MultiSelect, InputText, Dropdown},
  data() {
    return {
      editableUser: {} as User,
      selfEstimationOptions: null,
      certificateOptions: null,
      countryOptions: null,
    }
  },
  props: {
    user: {type: Object as () => User, required: true},
    disabled: {type: Boolean, default: false},
  },
  computed: {
    isLoggedIn(): boolean {
      return this.$store.getters.loggedIn;
    }
  },
  watch: {
    editableUser:
        {
          handler(user) {
            console.log('changeUser', user)
            this.$emit('changeUser', user)
          },
          deep: true
        }
  },
  methods: {
    getSelfEstimation() {
      axios.get(lookupURL + 'self_estimation?lang=' + this.$store.state.language)
          .then(res => this.selfEstimationOptions = res.data)
          .catch(e => console.log(e))
    },
    getCertificates() {
      axios.get(lookupURL + 'certificate?lang=' + this.$store.state.language)
          .then(res => this.certificateOptions = res.data)
          .catch(e => console.log(e))
    },
    getCountries() {
      axios.get(lookupURL + 'country')
          .then(res => this.countryOptions = res.data)
          .catch(e => console.log(e))
    }
  },
  mounted() {
    // load lookup lists for dropdowns
    this.getSelfEstimation()
    this.getCertificates()
    this.getCountries()

    if (this.user) {
      this.editableUser = Object.assign(this.editableUser, this.user)
    }
    // initialize dropdown with Switzerland set as default value
    if (this.editableUser.country == null) {
      this.editableUser.country = 43
    }
  }
})
